import IdbKvStore from "idb-kv-store";

export function store() {
    return new IdbKvStore("localstore");
}

export function set(key, val) {
    return store().set(key, val);
}

export function add(key, val) {
    return store().add(key, val);
}

export function get(key) {
    return store().get(key);
}

export async function getBang(key) {
    const val = await store().get(key);
    return val;
}

export function remove(key) {
    return store().remove(key);
}
